import React from 'react';
import { Routes, Route } from 'react-router-dom';

import PublicLayout from './common/PublicLayout';
import AddressDetails from './membership/AddressDetails';
import MembershipSelection from './membership/MembershipSelection';
import PaymentDetails from './membership/PaymentDetails';
import PersonalDetails from './membership/PersonalDetails';
import ReviewDetails from './membership/ReviewDetails';
import ThankYou from './membership/ThankYou';
import NotFound from './NotFound';

function Membership() {
  return (
    <PublicLayout>
      <Routes>
        <Route index element={<PersonalDetails />} />
        <Route path="address" element={<AddressDetails />} />
        <Route path="type" element={<MembershipSelection />} />
        <Route path="payment" element={<PaymentDetails />} />
        <Route path="review" element={<ReviewDetails />} />
        <Route path="thank-you" element={<ThankYou />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </PublicLayout>
  );
}

export default Membership;
